import { Box, Stack } from '@mui/material';
import DateRangeField from 'components/forms/fields/date-range-field/date-range-field.component';
import IncSwitchField from 'components/forms/fields/inc-switch-field/inc-switch-field.component';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

const SetClosedDatesForm = () => {
  const { t } = useTranslation();

  return (
    <Box className="field-container" display="grid">
      <DateRangeField
        name="dateRange"
        label={t('forms.setClosedDatesForm.fields.dateRange.label')}
        data-testid="SetClosedDatesForm.DateRange.Field"
        // Can't use disablePast due to testing purposes
        shouldDisableDate={date => date < DateTime.now().startOf('day')}
      />

      <Stack display="flex" direction="row" ml={1}>
        <Box width="50%">
          <IncSwitchField
            name="pickupClosed"
            label={t('forms.setClosedDatesForm.fields.pickupClosed.label')}
            data-testid="SetClosedDatesForm.PickupClosed"
          />
        </Box>
        <Box width="50%">
          <IncSwitchField
            name="deliveryClosed"
            label={t('forms.setClosedDatesForm.fields.deliveryClosed.label')}
            data-testid="SetClosedDatesForm.DeliveryClosed"
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default SetClosedDatesForm;
